import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import './styles.css';
import BasicDataPod from '../BasicDataPod';
import Link from '../BasicDataPod/Link';
import Value from '../BasicDataPod/Value';
import Description from '../BasicDataPod/Description';
import Select from '../Select';
import { getDollarFormattedText } from '../../utils/strings';

class CurrencyDataPod extends React.PureComponent {
  static propTypes = {
    header: PropTypes.string, // Optional
    tooltip: PropTypes.string, // Optional
    footer: PropTypes.string, // Optional
    content: PropTypes.shape({
      subTitle: PropTypes.string,
      currencyValues: PropTypes.array, // Array can have combinations of string/number
      incomeValues: PropTypes.array, // Array must be containing only string
      linkText: PropTypes.string, // Optional, provide only if needed
      linkUrl: PropTypes.string, // Required if linkText is provided
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: 0,
    };
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = e => {
    if (e.key === 'Enter') {
      document.activeElement.click();
    }
  };

  handleSelectChange = (_, item) => {
    this.setState({
      selectedOption: item.value,
    });
  };

  getSelectOptions = incomeValues => {
    return incomeValues.map((value, index) => {
      return {
        key: value,
        value: index,
        text: value,
      };
    });
  };

  render() {
    const { content, ...rest } = this.props;
    const { selectedOption } = this.state;
    const isMultipleValues = content.incomeValues && content.incomeValues.length > 0;
    const selectedValue = get(content, `currencyValues[${selectedOption}]`, '');

    return (
      <BasicDataPod {...rest}>
        <div className="currencypod-content-container">
          <Value value={getDollarFormattedText(selectedValue)} type="currency" />
          <Description text={content.subTitle} className="bolded" />
          {isMultipleValues && (
            <div className="multiple-income-values">
              <div className="value-subtext">Family Income</div>
              <Select
                data-cy="currencypod-selection"
                options={this.getSelectOptions(content.incomeValues)}
                value={selectedOption}
                icon="chevron down"
                onChange={this.handleSelectChange}
                aria-label="currency"
              />
            </div>
          )}
          {content.linkText && (
            <div className={`${isMultipleValues ? '' : 'single-value-link'}`}>
              <Link linkText={content.linkText} linkUrl={content.linkUrl} />
            </div>
          )}
        </div>
      </BasicDataPod>
    );
  }
}

export default CurrencyDataPod;
